import React from "react";
function Quotation () {
    return (

        <h2>Quotation</h2>
    )
    
}
export default Quotation;